// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileNoticeRegister_backIcon__kAQnZ","regiBtn":"AdminMobileNoticeRegister_regiBtn__SZ5rg"};